import React from 'react';
import './HowToPlayModal.css';

interface HowToPlayModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowToPlayModal: React.FC<HowToPlayModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="how-to-play-overlay" onClick={onClose}>
      <div className="how-to-play-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>

        <h2>How to Play</h2>

        <div className="modal-section">
          <h3>🎯 Objective</h3>
          <p><strong>Timed Mode:</strong> Match pairs of identical tiles before the 60-second timer expires!</p>
          <p><strong>Infinity Mode:</strong> Match tiles endlessly as the board regenerates with new tiles!</p>
        </div>

        <div className="modal-section">
          <h3>🎮 Controls</h3>
          <ul>
            <li>Click or tap a tile to select it</li>
            <li>Valid matches will highlight in gold</li>
            <li>Click a matching tile to make the match</li>
            <li>In timed mode, matched tiles disappear</li>
            <li>In infinity mode, matched tiles are replaced with new ones</li>
          </ul>
        </div>

        <div className="modal-section">
          <h3>🔓 Free Tiles</h3>
          <p>A tile is "free" if it has <strong>at least one open side</strong> (top, bottom, left, or right). You can only match tiles that are free!</p>
          <p className="example-text">Example: A tile in the corner with neighbors on two sides is still free because two sides are open.</p>
        </div>

        <div className="modal-section">
          <h3>🎨 Tile Colors</h3>
          <p>Tiles are colored by traditional Mahjong suits:</p>
          <ul className="color-list">
            <li><span style={{color: '#D32F2F'}}>🀇 Red</span> - Characters (Wan)</li>
            <li><span style={{color: '#388E3C'}}>🀐 Green</span> - Bamboo (Suo)</li>
            <li><span style={{color: '#1976D2'}}>🀙 Blue</span> - Dots (Bing)</li>
            <li><span style={{color: '#FFA726'}}>🀀 Orange</span> - Winds</li>
            <li><span style={{color: '#D32F2F'}}>🀄 Red</span> - Red Dragon</li>
            <li><span style={{color: '#388E3C'}}>🀅 Green</span> - Green Dragon</li>
            <li><span style={{color: '#E0E0E0'}}>🀆 White</span> - White Dragon</li>
          </ul>
        </div>

        <div className="modal-section">
          <h3>🏆 Scoring</h3>
          <ul>
            <li><strong>+100 points</strong> per match</li>
            <li><strong>+25 bonus</strong> for matches within 3 seconds</li>
            <li><strong>+50 bonus</strong> for matches within 1 second</li>
            <li><strong>+500 bonus</strong> for clearing the entire board</li>
            <li><strong>-10 points</strong> for selecting non-matching tiles</li>
            <li><strong>-50 points</strong> for using the hint button</li>
          </ul>
        </div>

        <div className="modal-section">
          <h3>🔀 Auto-Shuffle</h3>
          <p>If no valid moves remain, tiles automatically shuffle to ensure you can always continue playing!</p>
        </div>

        <div className="modal-section">
          <h3>💡 Hint Button</h3>
          <p>Click the "Show Hint" button to reveal a matching pair for 3 seconds. Using hints costs 50 points!</p>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayModal;
